/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { GEORGIA_TITLE, GEORGIA_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { GEORGIA_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';

class Georgia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">Туры из Минска в Грузию</h1>
        <p className="text_p">
          Мечтаете о путешествии, где горные пейзажи сочетаются с теплым
          гостеприимством, а древние храмы соседствуют с современными курортами?
          Грузия ждет вас! На сайте tourhunter.by вы найдете туры из Минска от
          ведущих туроператоров. Безвизовый режим, короткий перелет (около 3
          часов) и доступные цены делают Грузию идеальным направлением для
          белорусов.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Почему стоит выбрать тур в Грузию?</h2>
        <p className="text_p">
          Безвизовый въезд — для граждан Беларуси достаточно паспорта.
        </p>
        <p className="text_p">
          Близкая культура — доброжелательные жители, понятный менталитет.
        </p>
        <p className="text_p">
          Разнообразие туров: Экскурсионные туры по Тбилиси, Мцхете, Кахетии,
          пляжный отдых в Батуми и Кобулети, горнолыжные курорты Гудаури и
          Бакуриани зимой, винные туры — дегустации в лучших винодельнях.
        </p>
        <p className="text_p">
          Вкуснейшая кухня — хачапури, хинкали, сыры и легендарное грузинское
          вино.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Популярные направления в Грузии</h2>
        <p className="text_p">
          Тбилиси — столица с атмосферными улочками, серными банями и видом на
          крепость Нарикала.
        </p>
        <p className="text_p">
          Сванетия — горный край с башнями-саклями и тропами для трекинга.
        </p>
        <p className="text_p">
          Батуми — черноморский курорт с современной набережной и ботаническим
          садом.
        </p>
        <p className="text_p">
          Казбеги — символ Кавказа с церковью Святой Троицы на фоне горы Казбек.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Преимущества туров в Грузию из Минска</h2>
        <p className="text_p">
          Групповые и индивидуальные туры — выбирайте формат под ваш бюджет и
          интересы.
        </p>
        <p className="text_p">
          Все включено: Авиабилеты Минск–Тбилиси–Минск, проживание в отелях
          3*/4*/5*, экскурсии с русскоязычными гидами (приобретаются
          дополнительно), трансферы и страховка.
        </p>
        <p className="text_p">Гибкие даты — туры доступны круглый год.</p>
      </div>
      <div className="content_block">
        <p className="text_p">
          Грузия — страна, которая очарует вас с первого взгляда. Подарите себе
          яркие эмоции: закаты над Арагви, прогулки по старинным кварталам,
          аромат свежеиспеченного лаваша. Забронируйте тур из Минска уже сегодня
          — остальное мы берем на себя!
        </p>
      </div>
    </div>
  );

  render() {
    const isSnap = navigator.userAgent === 'ReactSnap';

    return (
      <div className="content">
        <Helmet>
          <title>{GEORGIA_TITLE}</title>
          <meta name="description" content={GEORGIA_DESCRIPTION} />
          <link rel="canonical" href="https://tourhunter.by/georgia/" />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/georgia/" />
          <meta property="og:title" content={GEORGIA_TITLE} />
          <meta property="og:description" content={GEORGIA_DESCRIPTION} />
          <meta
            property="og:image"
            content="https://tourhunter.by/file/binoculars-logo.png"
          />
        </Helmet>

        {!isSnap && (
          <ToursResultFunc countryFilter={getCountry(GEORGIA_NAME)} />
        )}

        <div className="container">{this.getText()}</div>
      </div>
    );
  }
}

export default Georgia;
